export default __webpack_public_path__ + "static/media/ddl-trangle.b87ce9f5.svg";